/**
 * @overview Media query defaults
 */

// Mobile
export const tiny = `(max-width: 349px)`;
export const mobile = `(min-width: 350px) and (max-width: 559px)`;
export const mobileUp = `(min-width: 350px)`;
export const mobileDown = `(max-width: 559px)`;

// Tablet portrait
export const tabletPortrait = `(min-width: 768px) and (max-width: 1023px)`;
export const tabletPortraitUp = `(min-width: 768px)`;
export const tabletPortraitDown = `(max-width: 1023px)`;

// Tablet landscape
export const tabletLandscape = `(min-width: 1024px) and (max-width: 1279px)`;
export const tabletLandscapeUp = `(min-width: 1024px)`;
export const tabletLandscapeDown = `(max-width: 1279px)`;

// Desktop screens
export const desktop = `(min-width: 1280) and (max-width: 1599px)`;
export const desktopUp = `(min-width: 1280px)`;
export const desktopDown = `(max-width: 1599px)`;
export const max = `(min-width: 1600px)`;
